/**
 * Judge.me's featured carousel trims each review to a few lines and offers no way to read the
 * rest, so this adds a "Read more" to any card whose text is cut off and shows the whole
 * review in a dialog styled like the rest of the site (see snippets/cc-judgeme.liquid).
 *
 * The carousel is drawn by Judge.me after the page loads and redrawn when it resizes, so the
 * cards are watched rather than read once.
 */
const STAR = '★';

const dialog = () => {
  let el = document.querySelector('.cc-jm-dialog');
  if (el) return el;
  el = document.createElement('dialog');
  el.className = 'cc-jm-dialog';
  el.innerHTML = `
    <button type="button" class="cc-jm-dialog__close" data-close aria-label="Close">
      <svg viewBox="0 0 24 24" aria-hidden="true"><path fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" d="M6 6l12 12M18 6L6 18"/></svg>
    </button>
    <div class="cc-jm-dialog__inner">
      <p class="cc-jm-dialog__stars" data-stars role="img"></p>
      <h2 class="cc-jm-dialog__title" data-title></h2>
      <p class="cc-jm-dialog__body" data-body></p>
      <p class="cc-jm-dialog__name" data-name></p>
    </div>`;
  document.body.appendChild(el);
  el.addEventListener('click', (e) => { if (e.target === el || e.target.closest('[data-close]')) el.close(); });
  return el;
};

const open = (card) => {
  const box = dialog();
  const rating = card.querySelector('.jdgm-carousel-item__review-rating');
  const stars = rating ? rating.querySelectorAll('.jdgm--on').length : 0;
  const title = card.querySelector('.jdgm-carousel-item__review-title')?.textContent.trim() || '';
  const body = card.querySelector('.jdgm-carousel-item__review-body')?.textContent.trim() || '';
  const name = card.querySelector('.jdgm-carousel-item__reviewer-name')?.textContent.trim() || '';
  const starsEl = box.querySelector('[data-stars]');
  starsEl.textContent = STAR.repeat(stars);
  starsEl.setAttribute('aria-label', `${stars} out of 5 stars`);
  box.querySelector('[data-title]').textContent = title;
  box.querySelector('[data-body]').textContent = body;
  box.querySelector('[data-name]').textContent = name;
  box.showModal();
  box.querySelector('[data-close]').focus();
};

const addButtons = () => {
  document.querySelectorAll('.jdgm-carousel-item__review').forEach((review) => {
    const body = review.querySelector('.jdgm-carousel-item__review-body');
    const content = review.querySelector('.jdgm-carousel-item__review-content');
    if (!body || !content) return;
    const clipped = body.scrollHeight - body.clientHeight > 2;
    const existing = review.querySelector('.cc-jm-more');
    if (!clipped) { existing?.remove(); return; }
    if (existing) return;
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'cc-jm-more';
    button.textContent = 'Read more';
    button.addEventListener('click', (e) => { e.stopPropagation(); open(review); });
    content.after(button);
  });
};

const start = () => {
  addButtons();
  const carousel = document.querySelector('.jdgm-carousel-wrapper');
  if (!carousel) return;
  new MutationObserver(() => addButtons()).observe(carousel, { childList: true, subtree: true });
  if ('ResizeObserver' in window) new ResizeObserver(() => addButtons()).observe(carousel);
};

if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
else start();
// Judge.me builds the carousel a moment after load, so look again once it settles.
window.addEventListener('load', () => setTimeout(start, 600));
